import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { BUTTON_COLOR, iButtonProps } from './../../../types/coreButtonTypes';
import CircularProgress from '@mui/material/CircularProgress';
import './coreButton.css';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const CoreButtons: React.FC<iButtonProps> = ({
  buttonText,
  coreBtnPill,
  onclick,
  uploadFileIcon,
  onfileSelect,
  showFileInput,
  className,
  disabled,
  loading,
  sx,
  startIcon,
  ...props
}) => {
  const pillShape = coreBtnPill ? 'Pill' : '';
  const component = uploadFileIcon ? 'label' : 'button';
  return (
    <Button
      className={`coreBtn${pillShape} ${className}`}
      disabled={disabled || loading}
      onClick={onclick}
      component={component}
      startIcon={startIcon}
      endIcon={uploadFileIcon}
      sx={{ ...sx }}
      {...props}
    >
      {loading ? <CircularProgress color={BUTTON_COLOR.INHERIT} size={20} /> : buttonText}
      {uploadFileIcon && showFileInput && (
        <VisuallyHiddenInput type="file" accept=".doc, .docx,.pdf" onChange={onfileSelect} />
      )}
    </Button>
  );
};

export default CoreButtons;
